import { Inline, Stack, vars } from '@etg/wings';
import { css, etiColors, mediaQueries } from '@eti/styles';
import Skeleton from '../../../../../common/components/Skeleton';

const SortingSkeleton = () => {
  const sortingOptionStyles = css`
    flex: 1;
    padding-inline-end: 16px;

    &:not(:first-child) {
      padding-inline-start: 16px;
    }

    &:not(:last-child) {
      border-right: 1px solid ${vars.colors.divider};
    }
  `;

  const sortingBarStyles = css`
    background: ${etiColors.white};
    border-radius: ${vars.card.borderRadius};
    padding: 16px;

    @media ${mediaQueries.medium.down} {
      display: none;
    }
  `;

  return (
    <Inline className={sortingBarStyles} spacing={0}>
      {[...Array(4)].map((_, index) => (
        <Stack className={sortingOptionStyles} key={index} spacing={8}>
          <Skeleton.Box height={18} width={50} />
          <Skeleton.Box height={12} />
        </Stack>
      ))}
    </Inline>
  );
};

export default SortingSkeleton;
